module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'social-services/static-in-line' && templateVars.config ?
				templateVars.config :
				{
	"animationClose": "transition.slideDownOut",
	"animationCloseDuration": 200,
	"animationOpen": "transition.slideUpIn",
	"animationOpenDuration": 200,
	"links": {
		"ru": [
			{
				"modifier": "twitter",
				"targetBlank": true,
				"url": "test_url_1_static",
				"text": "Twitter"
			},
			{
				"modifier": "facebook-multiple",
				"text": "Facebook",
				"links": [
					{
						"modifier": "facebook1",
						"targetBlank": true,
						"url": "test_url_2_static",
						"text": "Facebook1"
					},
					{
						"modifier": "facebook2",
						"targetBlank": true,
						"url": "test_url_2_static",
						"text": "Facebook2"
					},
					{
						"modifier": "facebook3",
						"targetBlank": true,
						"url": "test_url_2_static",
						"text": "Facebook3"
					}
				]
			},
			{
				"modifier": "linkedin",
				"targetBlank": true,
				"url": "test_url_3_static",
				"text": "Linkedin"
			},
			{
				"modifier": "vkontakte",
				"targetBlank": true,
				"url": "test_url_3_static",
				"text": "VKontakte"
			},
			{
				"modifier": "youtube",
				"targetBlank": true,
				"url": "test_url_3_static",
				"text": "YouTube"
			},
			{
				"modifier": "instagram",
				"targetBlank": true,
				"url": "test_url_3_static",
				"text": "Instagram"
			},
			{
				"modifier": "foursquare",
				"targetBlank": true,
				"url": "test_url_3_static",
				"text": "Foursquare"
			}
		],
		"en": [
			{
				"modifier": "twitter",
				"targetBlank": true,
				"url": "test_url_1_static",
				"text": "Twitter"
			},
			{
				"modifier": "facebook",
				"targetBlank": true,
				"url": "test_url_2_static",
				"text": "Facebook"
			},
			{
				"modifier": "linkedin",
				"targetBlank": true,
				"url": "test_url_3_static",
				"text": "Linkedin"
			},
			{
				"modifier": "vkontakte",
				"targetBlank": true,
				"url": "test_url_3_static",
				"text": "VKontakte"
			},
			{
				"modifier": "youtube",
				"targetBlank": true,
				"url": "test_url_3_static",
				"text": "YouTube"
			},
			{
				"modifier": "instagram",
				"targetBlank": true,
				"url": "test_url_3_static",
				"text": "Instagram"
			},
			{
				"modifier": "foursquare",
				"targetBlank": true,
				"url": "test_url_3_static",
				"text": "Foursquare"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/social-services/.variant/static-in-line/config.yaml
// module id = 160
// module chunks = 0